<template>
  <section class="login">
    <a-row class="login-row">


      <div class="logo"  :style=" 'background: url(' + this.axios.defaults.baseURL + '/setting/getLogo' + ') no-repeat center' " />

      <a-col class="login-form">
        <div class="login-form-content">
          <div class="login-form-left">

          </div>

          <div class="login-form-right login-form-right-1" v-if="formType===1">
            <h1>{{ loginTitle() }}</h1>
            <p>欢迎使用RoboWave Pilot - 凌动驾驶舱</p>
            <a-form-model ref="ruleForm" :model="ruleForm" :rules="ruleFormrules" @keypress.enter.native="submitForm('ruleForm')" style="position:relative;">
              <a-form-model-item has-feedback prop="username" >
                <a-input
                    v-model.trim="ruleForm.username"
                    placeholder="请输入账号"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="password"  key="password">
                <a-input-password
                    v-model="ruleForm.password"
                    type="password"
                    placeholder="请输入密码"
                >

                </a-input-password>
              </a-form-model-item>
              <p class="forgotPassword" v-if="formType===1">
                <label @click="forgetPassword(3)">
                  忘记密码？
                </label>
              </p>

              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" :loading="submitLoad" @click="submitForm('ruleForm')">
                  登录
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>


          <div class="login-form-right login-form-right-2 " v-if="formType===2">
            <header>
              <h1>{{ loginTitle() }}</h1>
              <a-tooltip  contenrt="" title="返回登录" placement="right" effect="light">
                <a-icon type="left-circle" theme="filled" @click="forgetPassword(1)"  />
              </a-tooltip>
            </header>
            <a-form-model ref="ruleForm" :model="ruleForm" :rules="ruleFormrules" @keypress.enter.native="submitForm('ruleForm')" style="position:relative;">
              <a-form-model-item has-feedback prop="username">
                <a-input
                    v-model.trim="ruleForm.username"
                    placeholder="请输入账号"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="oldPassword">
                <a-input-password
                    v-model="ruleForm.oldPassword"
                    type="password"
                    placeholder="请输入原密码"
                >
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="password"  style="position:relative;" key="password">
                <a-input-password
                    v-model="ruleForm.password"
                    type="password"
                    placeholder="请输入新密码"
                >
                </a-input-password>
                <a-tooltip   v-if="['2','3'].includes($store.state.user.getAccountPolicy.passwordComplexity)"  style="position:absolute;top: 0px;margin-left: 10px" content=""  title="特殊符号:()~!@#$%^&*_-+=|{}[]:;" placement="top" effect="light">
                  <a-icon type="exclamation-circle" />
                </a-tooltip>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="repassword">
                <a-input-password
                    v-model="ruleForm.repassword"
                    type="password"
                    placeholder="请再次输入新密码"
                >
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" :loading="submitLoad" @click="submitForm('ruleForm')">
                  保存
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>

          <div class="login-form-right login-form-right-3 " v-if="formType===3">
            <header>
              <h1>{{ loginTitle() }}</h1>
              <a-tooltip  content="" title="返回登录" placement="right" effect="light">
                <a-icon type="left-circle" theme="filled" @click="forgetPassword(1)"  />
              </a-tooltip>
            </header>
            <a-form-model ref="ruleForm" :model="ruleForm" :rules="ruleFormrules" @keypress.enter.native="submitForm('ruleForm')" style="position:relative;">
              <a-form-model-item has-feedback prop="username">
                <a-input
                    v-model.trim="ruleForm.username"
                    placeholder="请输入账号"
                    @change="inputChange"
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item prop="email" key="email">
                <a-input
                    v-model.trim="ruleForm.email"
                    placeholder="请输入邮箱号"
                    disabled
                >
                </a-input>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="password"  style="position:relative;" >
                 <a-input-password
                     v-model="ruleForm.password"
                     type="password"
                     placeholder="请输入新密码"
                 >
                 </a-input-password>
                 <a-tooltip   v-if="['2','3'].includes($store.state.user.getAccountPolicy.passwordComplexity)" style="position:absolute;top: 0px;margin-left: 10px" content=""  title="特殊符号:()~!@#$%^&*_-+=|{}[]:;" placement="top" effect="light">
                   <a-icon type="exclamation-circle" />
                 </a-tooltip>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="repassword">
                <a-input-password
                    v-model="ruleForm.repassword"
                    type="password"
                    placeholder="请再次输入新密码"
                >
                </a-input-password>
              </a-form-model-item>
              <a-form-model-item has-feedback prop="vercode" class="vercodeClass" key="vercode">
               <a-col :span="15" >
                 <a-input
                     v-model="ruleForm.vercode"
                     placeholder="请输入验证码"
                 >
                 </a-input>
               </a-col>
                <a-col :span="9">
                  <!-- 自动获取邮箱 -->
                  <a-button class="auto-get-emailcode" round @click="getEmailCode" v-loading="emailCodeLoad" :disabled="emailCodeLoad||emailCodeTimeOut">{{ emailCodeTimeOut?emailCodeTime+'s 重新发送':'获取验证码' }}</a-button>
                </a-col>
              </a-form-model-item>

              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button type="primary" :loading="submitLoad" @click="submitForm('ruleForm')">
                  保存
                </a-button>
              </a-form-model-item>
            </a-form-model>
          </div>
        </div>

      </a-col>
    </a-row>
    <div class="versionNumber"> Copyright © 2014-2024 中投创展, All Rights Reserved</div>

  </section>
</template>

<script>

export default {
  data() {
    return {
      submitLoad: false,
      ruleForm: {
        username: "",
        password: "", // 输入密码
        oldPassword:'', // 原密码
        repassword:'', // 再次输入新密码
        email:'',
        vercode:''
      },
      ruleFormrules: {
        username: [{ required: true, message: "用户名不能为空" }],
        password: [{validator: (rule, value, callback) => {
            if (this.formType!==1) {
              let passwordRule = '',promptText = '';
              switch (this.$store.state.user.getAccountPolicy.passwordComplexity) {
                case '1':
                  passwordRule = /^(?=.*[0-9])(?=.*[a-zA-Z])(.{6,})$/
                  promptText = '必须同时包含数字、英文字母'
                  break;
                case '2':
                  passwordRule = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[\(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/  ])[a-zA-Z0-9\(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/ ]+$/
                  promptText = '必须同时包含数字、英文字母和特殊字符'
                  break;
                case '3':
                  passwordRule = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ \(\)~!@#$%\^&\*_\-\+\=\|\{\}\[\]:;<>,\.\?/])(?!.*\s).{8,}$/
                  promptText = '必须同时包含数字、大写和小写字母以及特殊符号'
                  break;
              }
              if (value === "") {
                return callback(new Error("请输入新密码"));
              }
              // 可增加密码自定义规则
              if ((value ? value.length : 0 ) < Number(this.$store.state.user.getAccountPolicy.passwordLength) ) {
                return callback(new Error('至少' + this.$store.state.user.getAccountPolicy.passwordLength + '个字符,'+ promptText));
              }
              if ((value ? value.length : 0 ) > 15 ) {
                return callback(new Error("密码长度最大不能超过" + 15 + '个字符'));
              }
              // 可增加密码自定义规则
              if (passwordRule.test(value) !== true ) {
                return callback(new Error(promptText));
              }
            }
            if (value === '') {
              return callback(new Error('密码不能为空'));
            }
            callback()
          }, trigger: 'blur'}],
        oldPassword: [{ required: true, message: "原密码不能为空" }],
        vercode: [{ required: true, message: "邮箱验证码不能为空" }],
        repassword: [
          {validator: (rule, value, callback) => {
              if (value === '') {
                return callback(new Error('请再次输入新密码'));
              }
              if (value !== this.ruleForm.password) {
                return callback(new Error('新密码不一致，请重新输入!'));
              }
              callback();
            }, trigger: 'blur'},
        ],
      },
      formType: 1,   // 1是登录，2是修改密码，3是忘记密码
      emailCodeLoad: false,   // 获取邮箱验证码loading
      emailCodeTimeOut: false,   // 获取邮箱验证码计时遮罩
      emailCodeTime: 60,      // 获取邮箱验证码倒计时（秒）
      // 获取邮箱名
      forgotEmail:""
    };
  },
  methods: {
    // 登录
    submitForm(formName, e) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitLoad = true;
          this.axios.post('/key', '').then((res)=>{
            // console.log(res);
            if (res.code===200) {
              // 缓存公钥
              this.$store.commit('common/updatePublicKey', res.data)
              this.$encrypt.setPublicKey(res.data)
              return true
            }
            return false
          }).then((hasKey)=>{
            console.log(hasKey)
            if (hasKey) {
              let loginData = this.$lodash.cloneDeep(this.ruleForm)
              loginData.password = loginData.password.trim()
              loginData.password = this.$encrypt.encrypt(loginData.password)
              switch (this.formType){
                 // 登录
                case 1 :
                  this.axios
                      .post("/login", loginData)
                      .then((res) => {
                        this.submitLoad = false
                        if (res.code === 200) {
                          this.$notification.success({message:'登录成功！'})
                          this.$store.commit('user/login', res.data)
                          this.$store.commit('common/updatePageInfo')
                          this.$router.push('/')
                          sessionStorage.setItem('errorCodes', JSON.stringify([]))
                        }else if(res.code == 426){ // 超过60天未修改密码
                          this.$notification.warning({message:res.message})
                          const that = this
                          this.$confirm({
                            title: res.message,
                            // content: h => <div style="color:red;">Some descriptions</div>,
                            okText: '修改密码',
                            cancelText: '换账号登录',
                            class:"toUpdate-confirm",
                            onOk() {
                              that.formType=2
                              that.$refs.ruleForm.resetFields()
                            },
                            onCancel() {
                              that.$refs.ruleForm.resetFields()
                            },
                          });
                        }
                      })
                      .catch((err) => {
                        this.submitLoad = false;
                        console.log(err);
                      });
                  break
                // 修改密码
                case 2 :
                  loginData.oldPassword = loginData.oldPassword.trim()
                  loginData.oldPassword = this.$encrypt.encrypt(loginData.oldPassword)
                  loginData.repassword = loginData.repassword.trim()
                  loginData.repassword = this.$encrypt.encrypt(loginData.repassword)
                  this.axios
                      .post("/user/updateLoginPassword", loginData)
                      .then((res) => {
                        this.submitLoad = false
                        if (res.code === 200) {
                          this.formType = 1
                          this.$refs.ruleForm.resetFields()
                          this.$notification.success({message:res.message})
                        }
                      })
                      .catch((err) => {
                        this.submitLoad = false;
                        console.log(err);
                      });
                  break
                // 忘记密码
                case 3 :
                  loginData.oldPassword = loginData.oldPassword.trim()
                  loginData.oldPassword = this.$encrypt.encrypt(loginData.oldPassword)
                  loginData.repassword = loginData.repassword.trim()
                  loginData.repassword = this.$encrypt.encrypt(loginData.repassword)
                  this.axios
                      .post("/retrievePassword", loginData)
                      .then((res) => {
                        this.submitLoad = false
                        if (res.code === 200) {
                          this.formType = 1
                          this.$refs.ruleForm.resetFields()
                          this.$notification.success({message:res.message})
                        }
                      })
                      .catch((err) => {
                        this.submitLoad = false;
                        console.log(err);
                      });
                  break
              }

            }
          }).catch((err)=>{
            console.log(err);
          })

        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 登录表头名
    loginTitle(){
      switch (this.formType) {
        case 1:
          return '登录'
          break;
        case 2:
          return '修改密码'
          break;
        case 3:
          return  '忘记密码'
          break;
      }
    },
    // 忘记密码 || 返回登录
    forgetPassword(val){
      this.formType = val
      if (val == 3){
        this.inputChange()
      }
      this.ruleForm.password = ''
      this.ruleForm.oldPassword = ''
      this.ruleForm.repassword = ''
      this.ruleForm.email = ''
      this.ruleForm.vercode = ''
    },
    // 监听账户和租户 请求邮箱账户
    inputChange(val){
      if (window.searchTimer) {
        clearTimeout(searchTimer);
      }
      window.searchTimer = setTimeout(() => {
        if (this.ruleForm.username) {
          this.axios
              .post("/user/getEmail",{userName:this.ruleForm.username})
              .then((res) => {
                if (res.code === 200) {
                  this.forgotEmail =  res.data ?  res.data: ''
                  this.ruleForm.email =  res.data ?  res.data: ''
                  // this.ruleForm.email = res.data.result ? res.data.result.email.slice(0,3) + '****' + '@' + res.data.result.email.split('@')[1]: ''
                }
              })
              .catch((err) => {
                console.log(err);
              });
        }else{
          this.ruleForm.email = ''
          this.forgotEmail = ''
        }
      }, 1200);
    },
    // 获取邮箱验证码
    getEmailCode(){
      this.emailCodeTime = 60
      this.emailCodeLoad = true
      let obj ={
        username : this.ruleForm.username,
        email: this.forgotEmail,
      }
      this.axios.post('/sendEmailCode', obj).then((res)=>{
        this.emailCodeLoad = false
        if (res.code === 200) {
          this.emailCodeTimeOut = true
          this.$message.success('验证码已成功发送，请登录该用户邮箱查看！')
          let ectimeout = setInterval(() => {
            this.emailCodeTime--
            if (this.emailCodeTime===0) {
              clearInterval(ectimeout)
              this.emailCodeTimeOut = false
            }
          }, 1000);
        }
      }).catch((err)=>{console.log(err.message);this.emailCodeLoad=false})
    },
  },
  beforeMount() {
    // 获取账号策略
    this.axios
        .post("/getAccountPolicy")
        .then((res) => {
          if (res.code == 200) {
            this.$cookies.set('getAccountPolicy',JSON.stringify(res.data),"1d",'/')
            this.$store.commit('user/getAccountPolicyInfo')
          }
        })
        .catch((err) => {
          console.log(err);
        });
    // 许可证过期或者无许可证时，登录返回页面，控制样式去掉了许可证弹出框
    window.onload = () => {
      let model = document.getElementsByClassName('ant-modal-root')[0],model1 = document.getElementsByClassName('ant-modal-root')[1];
      model.style.display = 'none'
      model1.style.display = 'none'
    }




  }
};
</script>

<style lang="scss" scoped>


::v-deep  .ant-modal-body{
  top: 300px;

}
.login {
  position: absolute;
  width: 100%;
  height: 100%;
  .login-row {
    width: 100%;
    height: 100%;
    background: url("../assets/images/bg_login.png")  no-repeat center;
    display: flex;
    background-size: cover;
    .logo{
      width: 9%;
      height: 68px;
      background-size: contain !important;
      position: absolute;
      left: 1.5%;
      top: 0%;

    }

    .login-form {
      width: 100%;
      min-width: 770px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .ant-col {
        margin-bottom: 40px;
      }
      .login-form-content{
        display: flex;
        box-shadow: 0 4px 8px rgba(31,35,41,.03), 0 3px 6px -6px rgba(31,35,41,.05), 0 6px 18px 6px rgba(31,35,41,.03);

      }
      .login-form-left{
        border-bottom-left-radius: 0.4rem;
        border-top-left-radius: 0.4rem;
        width: 432px;
        height: 450px;
        background-image: url("../assets/images/bg_form_left.png");
      }
      .login-form-right{
        header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 30px;
          h1{
            margin-bottom: 0px;
          }
          i{
            cursor: pointer;
            font-size: 22px;
            color: #3c65f5;
          }
          i:hover{
            color: #6384f7;
          }
        }
        border-bottom-right-radius: 0.4rem;
        border-top-right-radius: 0.4rem;
        width: 432px;
        height: 450px;
        //box-shadow: 0 0 1.04  167vw rgb(1 117 255 / 20%);
        background-color: #ffffff;
        text-align: center;
        h1 {
          //margin-bottom: 80px;
          letter-spacing: 2px;
          font-size: 24px;
          text-align: left;
          font-weight: 600;
        }
        p{
          text-align: left;
          margin-bottom: 45px;
        }
        .forgotPassword{
          position: absolute;
          z-index: 99;
          right:-5px;
          margin-top: -5px;
          label{
            cursor: pointer;
            color: #86909c;
          }
          label:hover{
            color:#3c65f5
          }
        }

        .ant-icon{
          width: 16px;
          height: 16px;
          vertical-align: middle;
          margin-bottom: 3px;
        }
        ::v-deep .ant-input {
          background-color: #ffffff;
          color: #848a97;
          //width: 393px;
          height: 40px;
          &::placeholder {
            color: #747b8b;
          }
        }

        ::v-deep  .ant-input:focus{
          box-shadow: 0 0 8px rgba(24, 144, 255,.3);
        }
        .ant-btn-primary {
          width: 342px;
          height: 45px;
          margin: 55px 0 0 -56px;
          border: none;
          border-radius: 0.4rem;
          letter-spacing: 2px;
          background-color: #3373f2;
        }
        .has-error .ant-input:focus {
          box-shadow: 0 0 8px rgba(245,63,63,.3);
        }
        ::v-deep .has-error .ant-input-affix-wrapper .ant-input:focus{
          box-shadow: 0 0 8px rgba(245,63,63,.3);
        }
        .has-error .ant-input:focus {
          border-bottom: 1px solid #f56c6c;
        }
      }
      .login-form-right-1 {
        padding: 45px;

        .ant-btn-primary {
          margin:70px 0 0 -56px
        }
      }
      .login-form-right-2{
        padding: 30px 45px 45px;

        .ant-btn-primary {
          margin: 25px 0 0 -56px;
        }
      }
      .login-form-right-3{
        padding: 30px 45px 45px;
        header{
          margin-bottom: 20px;
        }
        .ant-input[disabled]{
          background-color: #f5f5f5;
        }
        .ant-btn-primary {
          margin: 0px 0 0 -56px;
        }
        .ant-col{
          margin-bottom: 0px;
        }
        .auto-get-emailcode {
          padding: 15px 30px;
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 115px;
          float: right;
          margin-top: 2px;
        }
        ::v-deep .vercodeClass{
          position: relative;
          .ant-form-item-children-icon{
            position: absolute;
            left: -160px;
            top: 21px;
          }
        }
      }
      .copywriting{
        position:absolute;
        bottom: 25px;
        right: 50px;
      }
    }
  }
  .versionNumber{
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
::v-deep .ant-form-explain {
  text-align: left;
  margin: 0px 0 0 0;
  font-size: 12px;
}
::v-deep .ant-form-item-with-help{
  margin-bottom: 2px !important;
}
::v-deep .ant-form-item{
  margin-bottom: 20px;
}
::v-deep .ant-form-explain{
  min-height: 16px;
}


</style>
